export var ErrorLogType;
(function (ErrorLogType) {
    ErrorLogType["InvalidEventTime"] = "Event time is invalid";
    ErrorLogType["InvalidEventType"] = "Event type is invalid";
    ErrorLogType["InvalidLuxonTimezone"] = "Designated luxon timezone is invalid";
    ErrorLogType["FailedToScrollGridTo"] = "Error occurred while scroll schedule grid to expected position";
})(ErrorLogType || (ErrorLogType = {}));
